"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("../constant");
var _constant3 = require("./constant");
var _default = {
  PropTypes: {
    scoreCallback: _propTypes.func,
    viewport: (0, _propTypes.oneOf)(Object.values(_constant2.DEVICE_TYPE)),
    isScoringTypeBiased: _propTypes.string,
    poorTag: _propTypes.string,
    excellentTag: _propTypes.string,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    defaultScore: _propTypes.number,
    minScore: _propTypes.number,
    maxScore: _propTypes.number,
    scoreHeight: _propTypes.string,
    scoreWidth: _propTypes.string,
    scoreLineHeight: _propTypes.string,
    scoreColor: _propTypes.string,
    keyIndex: _propTypes.number
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    scoreCallback: function scoreCallback() {},
    isScoringTypeBiased: 'TRUE',
    viewport: _constant2.DEVICE_TYPE.MOBILE,
    minScore: _constant3.SCORE.MIN,
    maxScore: _constant3.SCORE.MAX,
    scoreHeight: _constant3.DEFAULT_STYLE.SCORE_HEIGHT,
    scoreWidth: _constant3.DEFAULT_STYLE.SCORE_WIDTH,
    scoreLineHeight: _constant3.DEFAULT_STYLE.SCORE_LINE_HEIGHT
  }
};
exports.default = _default;